import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const candidateApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sendReminder: builder.mutation({
      query: (id) => ({
        url: (config.SendRemainderToApplicant || "") + id,
        method: "GET",
      }),
    }),
    loadCandidatesByFilter: builder.mutation({
      query: (data) => ({
        url: config.GetApplicantsByFilter || "",
        method: "POST",
        body: data,
      }),
    }),
    loadCandidateApps: builder.query({
      query: (id) => (config.GetPerformerApplication || "") + id,
      providesTags: ["CandidateApps"],
    }),
    loadCandidateAppAllTasks: builder.query({
      query: (id) => (config.GetAppAllWorkflowTasks || "") + id,
    }),
    loadAppRuningTasks: builder.query({
      query: ({ wfId, userId }) =>
        (config.GetRunningTask || "") + wfId + "&performerId=" + userId,
      providesTags: ["WorkflowTasks"],
      keepUnusedDataFor: 300, // Cache tasks for 5 minutes to prevent multiple components from making redundant requests
    }),
    loadAppDocuments: builder.query({
      query: ({ wfId, userId }) =>
        (config.GetReceivedDocuments || "") + userId + "&chkId=" + wfId,
      providesTags: ["Documents"],
    }),
    loadAppDocusignDocs: builder.query({
      query: (userId) => (config.GetDocusingDocuments || "") + userId,
    }),
    loadBackgroundChecks: builder.query({
      query: (userId) => (config.GetBackgroundChecks || "") + userId,
    }),
    loadSheduleMeeting: builder.query({
      query: (userId) => (config.GetSheduleMeeting || "") + userId,
      providesTags: ["Meetings"],
    }),
    acceptSheduleMeeting: builder.mutation({
      query: (option) => ({
        url: config.AcceptMeeting || "",
        method: "POST",
        body: option,
      }),
      invalidatesTags: ["Meetings", "WorkflowTasks"],
    }),
    sendSheduleMeetingLinks: builder.mutation({
      query: (option) => ({
        url: (config.SendMeetingDetails || "") + option,
        method: "GET",
      }),
      invalidatesTags: ["Meetings"],
    }),
    loadAppMessages: builder.query({
      query: ({ wfId, userId }) =>
        (config.GetPortalCommunication || "") + wfId + "&performerId=" + userId,
    }),
    loadAppFormLibrary: builder.query({
      query: ({ wfId, userId }) =>
        (config.GetApplicantFormsLibrary || "") + wfId + "&perfId=" + userId,
      providesTags: ["FormLibrary"],
    }),
    deleteUploadedDocument: builder.mutation({
      query: ({ id, type }) => ({
        url: (config.DeleteDocumentByApplicant || "") + id + "&type=" + type,
        method: "DELETE",
      }),
      invalidatesTags: ["Documents", "WorkflowTasks"],
    }),
    loadInvoiceDocuments: builder.query({
      query: (userId) => (config.GetAppInvoiceDocuments || "") + userId,
    }),
    loadReqDocuments: builder.query({
      query: (ciid) => (config.GetRequiredDocument || "") + ciid,
    }),
    uploadAppDocuments: builder.mutation({
      query: (data) => ({
        url: config.ApplicantUploadDocument || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Documents"],
    }),
  }),
});

export const {
  useSendReminderMutation,
  useLoadCandidatesByFilterMutation,
  useLoadCandidateAppsQuery,
  useLazyLoadCandidateAppsQuery,
  useLoadCandidateAppAllTasksQuery,
  useLazyLoadCandidateAppAllTasksQuery,
  useLoadAppRuningTasksQuery,
  useLazyLoadAppRuningTasksQuery,
  useLoadAppDocumentsQuery,
  useLazyLoadAppDocumentsQuery,
  useLoadAppDocusignDocsQuery,
  useLazyLoadAppDocusignDocsQuery,
  useLoadBackgroundChecksQuery,
  useLazyLoadBackgroundChecksQuery,
  useLoadSheduleMeetingQuery,
  useLazyLoadSheduleMeetingQuery,
  useAcceptSheduleMeetingMutation,
  useSendSheduleMeetingLinksMutation,
  useLoadAppMessagesQuery,
  useLazyLoadAppMessagesQuery,
  useLoadAppFormLibraryQuery,
  useLazyLoadAppFormLibraryQuery,
  useDeleteUploadedDocumentMutation,
  useLoadInvoiceDocumentsQuery,
  useLazyLoadInvoiceDocumentsQuery,
  useLoadReqDocumentsQuery,
  useLazyLoadReqDocumentsQuery,
  useUploadAppDocumentsMutation,
} = candidateApiSlice;
